import HomePage from 'components/pages/Home';

import { resolvify } from 'lib/promises';
import { removeWhitespaceBetweenCharacters } from 'lib/string';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getFeaturedOffersList, getOffersList } from 'services/offer';
import { getStoresList } from 'services/store';
import { getPasswordRecoveryHashValidation } from 'services/user';

import APP from 'constants/app';
import LINKS from 'constants/links';

const OFFERS_SERVER_LIMIT = 12;
const TAB_NAME = 'highlights';

const Index = ({
  cardsAds,
  landscapeAds,
  recoveryPassword,
  serverFeaturedOffers,
  serverOffers,
  smallAds,
}) => (
  <HomePage
    cardsAds={cardsAds}
    landscapeAds={landscapeAds}
    recoveryPassword={recoveryPassword}
    serverFeaturedOffers={serverFeaturedOffers}
    serverOffers={serverOffers}
    smallAds={smallAds}
  />
);

export const getServerSideProps = async ({ query }) => {
  try {
    const {
      ha: recoveryHash = null,
      em: rawUserEmail = null,
      pass_rec: isPasswordRecoveryMode,
    } = query;
    /**
     * In some edge cases the recovery email could contain the "+" character
     * like "example+1@test.com" and it is returned as "example 1@test.com"
     * which is not a valid email. We deal with it below
     */
    const userEmail = rawUserEmail
      ? removeWhitespaceBetweenCharacters(rawUserEmail.trim())
      : null;
    const isPasswordRecoveryModeEnabled = !!(
      isPasswordRecoveryMode &&
      recoveryHash &&
      userEmail
    );

    const [
      serverOffers,
      serverFeaturedOffers,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          cardAd: cardsAds = [],
          homeAd: landscapeAds = [],
          smallAd: smallAds = [],
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
      passwordRecovery,
    ] = await resolvify([
      getOffersList({ limit: OFFERS_SERVER_LIMIT, ...query }),
      { fn: getFeaturedOffersList(), fallback: getFeaturedOffersList.fallback },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
      {
        fn: () =>
          getPasswordRecoveryHashValidation({ recoveryHash, userEmail }),
        fallback: getPasswordRecoveryHashValidation.fallback,
        enabled: isPasswordRecoveryModeEnabled,
      },
    ]);

    let recoveryPassword = null;

    if (passwordRecovery?.isHashValid) {
      recoveryPassword = {
        recoveryHash,
        userEmail,
        isValid: true,
      };
    }

    return {
      props: {
        cardsAds,
        landscapeAds,
        recoveryPassword,
        serverFeaturedOffers,
        serverOffers,
        smallAds,
        [APP.CTX_OPTIONAL_PROPS]: {
          activeOffersListTab: TAB_NAME,
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[500], permanent: false } };
  }
};

export default Index;
